module.exports = __webpack_public_path__ + "fonts/Simple-Line-Icons.f33df365.eot";